import { useSelector } from 'react-redux';
import { Skeleton } from 'ui/skeleton';
import { Tooltip } from 'ui/tooltip';
import { kebabCase } from 'utils/stringHelpers';
import { formatNumberGivenValueType, tooltipValue } from 'modules/productAnalytics/utils';
import {
  SkeletonWrapper,
  MetricBreakdownContent,
  MetricBreakdownHeaderTitle,
  MetricBreakdownHeaderValue,
  OverviewRowWithTwoEqualColumns,
} from './Styled';
import { MetricBreakdownCard } from './MetricBreakdownCard';
import { METRIC_CARD_DATA_LOOKUP } from '../constants';
import { parseMetricsForBreakdown } from '../utils';
import { selectAnalyticsMetricsValueTypes } from '../selectors';

const getMetrics = (messageMedium, statsForTimeRange, cardType) => ({
  overviewMetrics: parseMetricsForBreakdown(
    METRIC_CARD_DATA_LOOKUP[cardType][messageMedium]?.values || [],
    statsForTimeRange?.results,
  ),
});

export const MetricCardSmall = ({ messageMedium, statsForTimeRange, cardType, isLoading }) => {
  if (!METRIC_CARD_DATA_LOOKUP[cardType][messageMedium]?.header) return null;
  const valueTypes = useSelector(selectAnalyticsMetricsValueTypes);
  const { overviewMetrics } = getMetrics(messageMedium, statsForTimeRange, cardType);
  const metrics = overviewMetrics.flat();
  return (
    <MetricBreakdownCard
      title={METRIC_CARD_DATA_LOOKUP[cardType][messageMedium].header}
      data-test={`${METRIC_CARD_DATA_LOOKUP[cardType][messageMedium].header}-card-small`}
    >
      {isLoading ? (
        <SkeletonWrapper height={135} padding={24}>
          <Skeleton />
        </SkeletonWrapper>
      ) : (
        <MetricBreakdownContent>
          <OverviewRowWithTwoEqualColumns>
            {metrics.map(({ name, value, key }, index) => {
              const headerMetricTooltipValue = tooltipValue(name, value);
              return (
                <div key={index}>
                  <MetricBreakdownHeaderTitle data-test={`metric-title-${kebabCase(name)}`}>
                    {name}
                  </MetricBreakdownHeaderTitle>
                  <MetricBreakdownHeaderValue data-test={`metric-value-${kebabCase(name)}`}>
                    <Tooltip
                      isEnabled={!!headerMetricTooltipValue}
                      tooltipContent={headerMetricTooltipValue}
                    >
                      {formatNumberGivenValueType(valueTypes[key], value) || 'N/A'}
                    </Tooltip>
                  </MetricBreakdownHeaderValue>
                </div>
              );
            })}
          </OverviewRowWithTwoEqualColumns>
        </MetricBreakdownContent>
      )}
    </MetricBreakdownCard>
  );
};
